import React from "react";
import { getMicrofrontendSlotsByName } from "@enpowered/microfrontends";
import { useQuery } from "react-query";
import { getMicrofrontendManifests } from "../services";

const navItems = [
  {
    name: "Bill Management",
    icon: "fa-money-bill-wave-alt",
    url: "/bill-management",
    disabled: process.env.REACT_APP_BILL_MANAGEMENT ? false : true,
    priority: 4
  },
  {
    name: "Demand Response",
    icon: "fa-bolt",
    url: "/demand-response",
    disabled: true,
    priority: 7
  },
  {
    name: "Sub Meters",
    icon: "fa-tachometer-alt",
    url: "/meter-management",
    disabled: true,
    priority: 8
  }
];

export const useSideNavItems = ({ user, getMicrofrontendManifests } = {}) => {
  const { data: manifests = [] } = useQuery(
    "manifests",
    getMicrofrontendManifests
  );
  return navItems
    .concat(
      getMicrofrontendSlotsByName(manifests, "side-nav:item", {
        user,
        host: "internal-portal"
      })
    )
    .sort((a, b) =>
      a.priority > b.priority ? 1 : a.priority < b.priority ? -1 : 0
    )
    .map(slot => ({
      ...slot,
      text: slot.name,
      name: slot.name,
      url: slot.url,
      icon: () => iconComponent(slot),
      Icon: () => iconComponent(slot),
      disabled: ["true", true].includes(slot.disabled)
    }));
};

const iconComponent = slot =>
  slot.icon.startsWith("svg") ? (
    <i>
      <img className="mx-2 w-5" src={slot.icon.replace("svg:", "")} />
    </i>
  ) : (
    <i className={`fa-fw fas ${slot.icon} mx-2`}></i>
  );

useSideNavItems.defaultProps = {
  getMicrofrontendManifests
};
